// Shrinks phone photos before upload (8–12 MB → ~0.5 MB) so Drive uploads
// finish in seconds instead of minutes. Falls back to the original file when
// the browser can't decode it (e.g. HEIC on Chrome) or it is already small.
const MAX_SIDE = 2048;
const QUALITY = 0.86;
const SKIP_BELOW = 900 * 1024;

export async function compressImage(file) {
  if (!file || !file.type?.startsWith("image/") || file.size < SKIP_BELOW) return file;
  try {
    const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    const w = Math.round(bitmap.width * scale);
    const h = Math.round(bitmap.height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, w, h);
    bitmap.close?.();
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", QUALITY));
    if (!blob || blob.size >= file.size) return file;
    const name = file.name.replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg", lastModified: file.lastModified });
  } catch (_) {
    return file;
  }
}

// Run `fn` over `items` with at most `limit` in flight; keeps input order.
export async function mapLimit(items, limit, fn) {
  const out = new Array(items.length);
  let i = 0;
  const workers = Array.from({ length: Math.min(limit, items.length) }, async () => {
    while (i < items.length) {
      const idx = i++;
      out[idx] = await fn(items[idx], idx);
    }
  });
  await Promise.all(workers);
  return out;
}
